import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import moment from 'moment';
import { Dropdown } from 'semantic-ui-react';
import { Button } from '../../Button';
import ProfilePic from '../../Header/profile-pic.svg';
import { ProjectViewConsumer } from '../../../containers/ProjectView/ProjectView.context';
import check from "../../EditProfileMobile/Check.svg";
import cross from "../../EditProfileMobile/Cross.svg";

const ProjectViewManagerHeader = ({
  project: {
    status,
    manager,
    deadline,
    freelancer,
    project_name: projectName,
    client: { type, name, email, avatar_url: avatarUrl },
  },
  project,
}) => {
  const [open, setOpenPopup] = useState(false);
  const isPending = status === 'pending';
  const isActive = status === 'active';
  const isRejected = status === 'rejected';

  const transformDropdowOptions = options =>
    options.map(({ key, value, text }) => ({
      key,
      value,
      text: <div className="custom-option">{text}</div>,
    }));

  return (
    <ProjectViewConsumer>
      {({
        handleUpdateProjectStatus,
        handleChangeFreelancer,
        handleChangeManager,
        handleEditProject,
        freelancers,
        isLoading,
        managers,
      }) => (
        <div className="row px-2 mt-11 bg-white shadow-mid manager-block">
          <div className="col-12">
            <div className="align-self-stretch">
              <div className="row">
                <div className="col-12 col-md-6 col-xl py-4">
                  <p className="t-13 mb-0 text-gray-2 header-title">
                    This project is still pending. Select an Account Manager and
                    and Freelancer to finish moving the project from pending
                    active.
                  </p>
                </div>
                <div className="col-12 col-md-6 col-xl py-3">
                  {isPending && (
                    <React.Fragment>
                      <div className="row my-4 desktop-buttons">
                        <div className="col-12 col-md-6 mb-3 mb-md-0">
                          <Button
                            title="Reject"
                            block
                            disabled={isLoading}
                            onClick={() => setOpenPopup(!open)}
                            className="btn-md btn-danger"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <Button
                            title="Accept"
                            block
                            disabled={isLoading}
                            onClick={() => handleUpdateProjectStatus('active')}
                            className="btn-md btn-primary"
                          />
                        </div>
                      </div>
                      <div className="row my-4 mobile-buttons">
                        <div className="col-12 col-md-6 mb-3 mb-md-0">
                          <Button
                            title="Reject"
                            block
                            disabled={isLoading}
                            onClick={() => setOpenPopup(!open)}
                            className="btn-md btn-danger"
                          />
                        </div>
                        <div className="col-12 col-md-6">
                          <Button
                            title="Accept"
                            block
                            disabled={isLoading}
                            onClick={() => handleUpdateProjectStatus('active')}
                            className="btn-md btn-primary"
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                  {isActive && (
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <span className="text-gray t-12">
                          Account Manager *
                        </span>
                        <Dropdown
                          placeholder="Manager"
                          fluid
                          selection
                          search
                          options={transformDropdowOptions(managers)}
                          defaultValue={manager ? manager.id : null}
                          onChange={handleChangeManager}
                          loading={isLoading}
                          disabled={isLoading}
                        />
                      </div>
                      <div className="col-12 col-md-6">
                        <span className="text-gray t-12">Freelancer *</span>
                        <Dropdown
                          placeholder="Freelancer"
                          fluid
                          selection
                          search
                          options={transformDropdowOptions(freelancers)}
                          disabled={isLoading}
                          defaultValue={get(freelancer, 'id')}
                          onChange={handleChangeFreelancer}
                          loading={isLoading}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-12 col-md-6 col-xl border-xl-left border-xl-right py-4 d-flex justify-content-center">
                  <div className="row">
                    <div className="col d-flex align-items-center">
                      <div
                        className="nav-item-avatar-md"
                        style={{
                          backgroundImage: `url(${avatarUrl || ProfilePic})`,
                        }}
                      />
                      <div className="details ml-2">
                        <p className="t-15 mb-0 text-capitalize text-gray-mate mb-0">
                          {name}
                        </p>
                        <p className="t-12 mb-0 text-gray-2 font-weight-mid mb-1">
                          {type}
                        </p>
                        <p className="t-12 mb-0 text-uppercase text-dark-teal cursor-pointer  font-weight-mid">
                          <a href={`mailto:${email}`}>{email}</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-xl py-4 d-flex">
                  <div className="row align-items-center align-self-stretch flex-fill">
                    {false && (
                      <div className="col">
                        <div className="w-100 text-center">
                          <p className="text-gray t-12 font-weight-medium mb-1">
                            DEADLINE
                          </p>
                          <span className="text-gray-2 t-19 font-weight-mid font-montserrat">
                            {moment(deadline, 'YYYY-MM-DD').format('MM/DD/YYYY')}
                          </span>
                        </div>
                      </div>
                    )}
                    {!isRejected && (
                      <div className="col text-center">
                        <Button
                          title="Edit Project"
                          disabled={isLoading}
                          onClick={() => handleEditProject(project)}
                          className="btn-outline-primary btn-md t-15"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            isOpen={open}
            toggle={() => setOpenPopup(!open)}
            centered
            className="modal-ml dashboard__content--project-actions-discard--confirm"
          >
            <ModalHeader toggle={() => setOpenPopup(!open)}>
              <span className="t-18 font-weight-extrabold">
                Discard {projectName}
              </span>
            </ModalHeader>
            <ModalBody>
              <p className="text-gray-light t-15">
                Are your sure? All materials will be deleted. You will not be
                <br />
                able to undo this.
              </p>
            </ModalBody>
            <ModalFooter className="d-flex justify-content-end border-0">
              <Button
                transparent
                className="t-14 px-4 text-danger"
                inline
                title="Delete"
                onClick={() => {
                  handleUpdateProjectStatus('rejected');
                  setOpenPopup(!open);
                }}
              />
              <Button
                transparent
                className="t-14 px-4 text-gray"
                inline
                title="Cancel"
                onClick={() => setOpenPopup(!open)}
              />
            </ModalFooter>
          </Modal>
        </div>
      )}
    </ProjectViewConsumer>
  );
};

ProjectViewManagerHeader.propTypes = {
  project: PropTypes.shape({
    user: PropTypes.shape({
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      avatar_url: PropTypes.string,
    }),
    project_name: PropTypes.string.isRequired,
    project_brief: PropTypes.string.isRequired,
    deadline: PropTypes.string.isRequired,
  }),
};

export default ProjectViewManagerHeader;



// WEBPACK FOOTER //
// ./src/components/ProjectView/ProjectViewManagerHeader/ProjectViewManagerHeader.js